/**
 * Seeded PRNG for game rules (mulberry32). Same seed → same sequence, in the browser and in Node,
 * so the server can re-simulate a match (docs/PROTOCOL.md). Never use Math.random in src/core/.
 */
export interface Rng {
  /** Float in [0, 1). */
  next(): number
  /** Integer in [0, max). */
  int(max: number): number
  /** How many numbers were drawn: goes into state checkpoints. */
  readonly index: number
}

export function createRng(seed: number): Rng {
  let a = seed >>> 0
  let index = 0
  const next = () => {
    index++
    a = (a + 0x6d2b79f5) >>> 0
    let t = a
    t = Math.imul(t ^ (t >>> 15), t | 1)
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61)
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }
  return {
    next,
    int: (max: number) => Math.floor(next() * max),
    get index() { return index }
  }
}
